import { deleteCookie } from './cookies';

export function deleteStoredData(key: string): void {
  try {
    deleteCookie(key);
  } catch (e) {
    return;
  }
}
